import { WifiOff } from 'lucide-react';
import FeatureModuleSection from '@/components/marketing/features/v2/FeatureModuleSection';

function OfflineDemo() {
  return (
    <div className="w-full max-w-sm border-[3px] border-charcoal-800 bg-charcoal-800 p-6 text-white shadow-neobrutal-lime-10">
      <div className="flex items-center justify-between border-b border-charcoal-700 pb-3">
        <span className="font-marketing-mono text-[11px] uppercase tracking-[0.12em] text-charcoal-200">
          Comptoir · Service
        </span>
        <span className="inline-flex items-center gap-1.5 border border-terracotta-400 px-2 py-0.5 font-marketing-mono text-[10px] uppercase tracking-[0.08em] text-terracotta-400">
          <WifiOff className="h-3 w-3" strokeWidth={2.4} />
          Hors ligne
        </span>
      </div>

      <div className="mt-4 space-y-2.5">
        {[
          { label: 'Mojito × 2', delta: '−100 ml rhum' },
          { label: 'Gin tonic × 1', delta: '−40 ml gin' },
        ].map((row) => (
          <div
            key={row.label}
            className="flex items-center justify-between border-[1.5px] border-charcoal-700 px-3 py-2.5 font-marketing-body text-[13.5px]"
          >
            <span className="text-charcoal-100">{row.label}</span>
            <span className="font-marketing-mono text-[12px] font-semibold text-lime-400">
              {row.delta}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-charcoal-700 pt-3 font-marketing-mono text-[11px] uppercase tracking-[0.08em]">
        <span className="text-charcoal-200">2 ventes en file</span>
        <span className="text-lime-500">Sync au retour réseau</span>
      </div>
    </div>
  );
}

export default function BarOfflineV2() {
  return (
    <FeatureModuleSection
      id="bar-offline"
      num="03 / Hors ligne"
      eyebrow="Tolérance réseau"
      sectionLabel="Au comptoir, toujours"
      title={
        <>
          Ça compte même quand <span className="underline-lime">le réseau lâche.</span>
        </>
      }
      description="La consommation d'ingrédients est déduite en local, à la vente, même sans connexion. Les mouvements partent en file d'attente chiffrée et se synchronisent dès que le réseau revient — rien n'est perdu."
      bullets={[
        'Déduction de recette en local sur le POS mobile et desktop',
        'File d\'attente chiffrée, synchro delta au retour réseau',
        'Inventaire à l\'aveugle réalisable hors ligne',
      ]}
      demo={<OfflineDemo />}
      Icon={WifiOff}
      reversed
      tone="paper"
    />
  );
}
